
const enum MarketStatus {
    'Unopened',
    'Opened',
    'Absent',
    'Closed',
    'Paused',
    'Canceled'

};
import { Marketday } from '../marketday';
import { MarketdateBooth } from '../marketdate-booth';
import { MarketdateComment } from '../marketdate-comment';
import { MarketdateExpense } from '../marketdate-expense';
import { MarketdateMeterreading } from '../marketdate-meterreading';
import { MarketdateStatus } from '../marketdate-status';
export class Marketdate {
    constructor(
        public id?: number,
        public marketdayNumber?: string,
        public originalDate?: any,
        public evasiveDate?: any,
        public holiday?: boolean,
        public canceled?: boolean,
        public comment?: string,
        public updated?: any,
        public created?: any,
        public gguid?: string,
        public status?: MarketStatus,
        public marketday?: Marketday,
        public marketdateBooths?: MarketdateBooth,
        public marketdateComments?: MarketdateComment,
        public marketdateExpenses?: MarketdateExpense,
        public marketdateMeterreadings?: MarketdateMeterreading,
        public marketdateStatuses?: MarketdateStatus,
    ) {
        this.holiday = false;
        this.canceled = false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate/marketdate.model.ts